<template lang="pug">

.pp(v-infinite-scroll="loadMore" :infinite-scroll-distance="distance" v-if="showPlaybyplays")
	NavQuarter
	Loading(v-if="!loaded" v-show="initialFail")
	Play(
		v-else
		v-for="(play, index) in showPlaybyplays"
		:key="(play.order == 10) ? (play.id_license+play.crono) : play.order"
		:play="play"
	)
	.pp-go_top(
		:class="showGoTop ? 'pp-go_top--show' : ''"
		@click="goTop"
		role="button"
		)
		span {{$t('Go top')}}
		i: font-awesome-icon(icon="arrow-circle-up")

</template>

<style lang="sass">

$score-size: 100px
.pp
	position: relative
	max-width: 800px
	width: 100%
	display: grid
	grid-auto-flow: row
	grid-gap: 4rem
	padding: 4rem 2rem 16rem 1.5rem
	box-sizing: border-box
	margin: 0 auto
	overflow: hidden

	+breakpoint(medium)
		padding: 4rem 2.5rem 16rem 2.5rem

	span
		letter-spacing: 0.2px

	&-go_top
		width: 100%
		position: fixed
		display: grid
		visibility: hidden
		opacity: 0
		transition: visibility 0s, opacity 0.5s
		grid-auto-flow: column
		grid-gap: 0.5rem
		align-items: center
		justify-content: end
		bottom: 0
		right: 0
		padding: 3rem 1rem 2rem 0rem
		box-sizing: border-box
		background-image: linear-gradient(to top,rgba(#ECECEC,1) 0%,rgba(#ECECEC,0))
		+breakpoint(large)
			width: initial
			background-image: none
			padding: 3rem 4rem 2rem 0rem
		
		&--show
			visibility: visible
			opacity: 1
		@media (hover: hover) and (pointer: fine)
			&:hover
				cursor: pointer
				span
					opacity: 1

		span
			opacity: 0
			transition: opacity 0.3s
			font-size: 1.2rem
			font-weight: $bold
			color: $primary-color
		i
			font-size: 2.2rem
			color: $primary-color


	
	&-item
		max-width: 500px
		width: 100%
		display: flex
		flex-direction: column
		align-items: flex-start
		+breakpoint(medium)
			align-items: flex-end
		&-wrap
			display: grid
			grid-auto-flow: row
			grid-gap: 2rem
		&--scored
			.pp-item-mes-info, .pp-item-mes-score__local
				background: $primary-color
		&--visitor
			.pp-item-mes-info
				background-color: $visitor
				&-icon
					border-left: 1px solid $white
					+breakpoint(medium)
						border-right: 0 

			.pp-item-mes__team
				transform: translateX(60%)
				right: 0
				left: initial
			&.pp-item--scored
				.pp-item-mes-info, .pp-item-mes-score__visitor
					background: $primary-color
				.pp-item-mes-score__local
					background-color: $local
		
		&--global
			.pp-item-mes-info
				background-color: $white
				color: $black
				margin: 0
				padding: 0
				&__text
					padding: 0 2rem

		+breakpoint(medium)
			width: calc(50% + (100px*0.5))

			&--global
				align-items: center
				justify-self: center
				width: initial
				max-width: 300px
				.pp-item-mes-info
					justify-content: center
			
			&--visitor
				justify-self: flex-end
				align-items: flex-start
				.pp-item-mes
					flex-direction: row-reverse
					&-info
						margin-left: 0
						padding-left: 0
						flex-direction: row-reverse
						justify-content: flex-end
						&-icon

		&-glo
			display: flex
			flex-direction: column
			align-items: center
			justify-content: center
			width: $score-size
			&__shield
				max-height: 30px
				padding-bottom: 0.5rem
		&-mes
			display: flex
			position: relative
			flex-direction: row-reverse
			justify-content: space-between
			width: 100%
			align-self: center
			height: 50px
			+breakpoint(medium)
				flex-direction: row


			&__team
				position: absolute
				width: 35px
				height: 35px
				object-fit: contain
				bottom: 0
				transform: translateX(60%)
				right: 0
				+breakpoint(medium)
					right: initial
					left: 0
					transform: translateX(-60%)

			&-info
				flex-grow: 1
				display: flex
				flex-direction: row-reverse
				align-items: center
				justify-content: space-between
				background-color: $local
				color: $white
				+breakpoint(medium)
					flex-direction: row
				&--scored
					background-color: $primary-color !important
				&-text
					position: relative
					margin: 0
					padding: 0 1em
					line-height: 1.4em
					font-size: 0.9em
					text-align: right
					display: flex
					flex-direction: column
					line-height: 1.3em
					
					&__stats
						color: $light-grey

					+breakpoint(medium)
						font-size: 1em
						text-align: inital
						align-items: flex-start

				&-icon
					flex-basis: 18px
					display: flex
					justify-content: center
					align-items: center
					padding: 0 0.7rem
					height: 18px				
					+breakpoint(medium)
						border-right: 1px solid $white
						padding: 0 1rem
					img
						width: 100%
			&-score
				flex-basis: $score-size
				flex-shrink: 0
				display: flex
				align-items: center
				& > *
					display: flex
					flex-basis: 50%
					text-align: center
					color: $white
					
					font-weight: $bold
					justify-content: center
					align-items: center
					height: 100%
					font-size: 1.3rem
					+breakpoint(medium)
						font-size: 1.5rem
				&__local
					background-color: $local
					&--scored
						background: $primary-color
				&__visitor
					background-color: $visitor
					&--scored
						background: $primary-color
			&-portrait
				position: relative
				flex-basis: 40px
				flex-shrink: 0
				font-size: 1em
				display: flex
				flex-direction: column
				align-items: center
				+breakpoint(medium)
					flex-basis: 50px
				&__img
					width: 100%
					height: 100%
					object-fit: cover

				&__name
					position: absolute
					transform: translateY(-100%)
					
					
	
</style>


<script>

import api from "@/api/index"
import NavQuarter from "@/components/subcomponents/nav/NavQuarter.vue"
import Loading from "@/components/subcomponents/general/Loading.vue"
import Play from "@/components/subcomponents/Play.vue"

import AOS from 'aos'
import 'aos/dist/aos.css'

import infiniteScroll from 'vue-infinite-scroll'

export default {
	name: "Playbyplay",
	data(){
		return {
			loaded: false,
			playbyplays: [],
			new_playbyplays: [],
			loaded_number: 3,

			initialFail: false,
			initialTimer: null,
		}
	},
	computed: {
		distance() {
			AOS.refresh()
			return 500 + this.loaded_number * 400
		},
		localImage() {
			return this.$store.state.match.localImage
		},
		refreshSignal() {
			return this.$store.state.general.refreshSignal
		},
		visitingImage() {
			return this.$store.state.match.visitorImage
		},
		showPlaybyplays() {
			return this.filteredPlays.slice(0,this.loaded_number)
		},
		showGoTop() {
			return this.$store.state.general.scrollTop > 250
		},
		period() {
			return this.$store.state.match.selQuarter
		},
		filteredPlays() {
			if (this.period == 0) {
				return this.$data.playbyplays
			} else {
				let filtered_plays = []
				for (let play of this.playbyplays){
					if (play.periodo == this.period) {
						filtered_plays.push(play)
					}
				}
				return filtered_plays
			}
		}
	},
	methods:{
		// debugNewPbP() {
		// 	// this.updateNewPlaybyplays()
		// 	// setInterval(() => {
		// 		let play = this.$data.playbyplays[3]
		// 		play.order = play.order+1234567
		// 		this.$data.new_playbyplays == this.$data.playbyplays.unshift(play)
		// 		this.setNewPlays()
		// 	// }, 1000)
		// },
		goTop() {
			this.$parent.goTop()
		},
		updatePlaybyplays() {
			api.match.getPlaybyplays(this.$route.params.id_match)
			.then((data) => {
				this.$data.playbyplays = data
				this.$data.loaded = true
				this.clearInitialTimer()
			})
		},
		updateNewPlaybyplays() {
			api.match.getPlaybyplays(this.$route.params.id_match)
			.then((data) => {
				this.new_playbyplays = data
				// this.new_playbyplays = this.$data.playbyplays.unshift(this.$data.playbyplays[100])
				this.setNewPlays()
				this.$data.loaded = true
				this.clearInitialTimer()
			})
		},
		addPlay(new_plays) {
			if (new_plays) {
				for (let play of new_plays.reverse()) {
					this.playbyplays.unshift(play)
				}
			}
		},
		loadMore() {
			AOS.refresh()
			if (this.loaded_number < (this.playbyplays.length-1))
				this.loaded_number += 15
		},
		newPlaysNumber() {
			let i = 0
			for (let play in this.new_playbyplays) {
				if (this.new_playbyplays[play].order == this.playbyplays[0].order)
					return i
				i++
			}
			return 0
		},
		getNewPlays() {
			let new_plays_number = this.newPlaysNumber()
			
			if (new_plays_number > 0) {
				return this.new_playbyplays.slice(0,new_plays_number)
			}
		},
		setNewPlays() {
			this.addPlay(this.getNewPlays())
		},
		filterQuarter() {
		},
		setInitialTimer() {
			this.timer = setTimeout(
				() => {
					this.$data.initialFail = true
				},
				this.$store.state.general.requestTimeout
			)
		},
		clearInitialTimer() {
			if (this.initialTimer) {
				this.$data.initialFail = false
				clearTimeout(this.initialTimer)
			}
		},
	},
	watch: {
		period() {
			this.loaded_number = Math.round(window.innerHeight/120)
			
		},
		refreshSignal(newValue) {
			if (newValue) {
				if (this.$store.state.match.status == "playing" || this.$store.state.general.refreshing)
					if (this.playbyplays[0])
						this.updateNewPlaybyplays()
					else
						this.updatePlaybyplays()
			}
		}
	},
	created() {
		this.setInitialTimer()
		this.updatePlaybyplays()
		AOS.init({
			offset: 0,
			delay: 0
		})
		this.loaded_number = Math.round(window.innerHeight/120)
		this.loadMore()
		setInterval(() => {
				AOS.refresh()
		}, 50);
	},
	mounted() {
		this.$parent.triggerGlobalRefresh()
		this.$parent.goTop()
	},
	directives: {
		infiniteScroll
	},
	components: {
		NavQuarter,
		Loading,
		Play
	}
}

</script>